// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"TransactionsChart_formWrapper__1acyw"};